export default __webpack_public_path__ + "static/media/photo6.13b593fc.jpg";